import EditName from './EditName';
import { FormInputsTypes, SettingsTabType } from 'constants/settings.constants';
import EditEmail from './EditEmail';
import EditPhone from './EditPhone';
import EditLanguage from './EditLanguage';
import MobileNavbar from 'sections/layout/MobileNavbar';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getMobile, togglePage } from 'state/reducers/ui.reducers';
import { pagesEnum } from 'constants/ui.constants';
import { useParams } from 'react-router-dom';
import { Page } from 'theme/elements/Page';

export default function ProfileEdit(props: { dataToEdit?: any; handleCancelEdit?: any; userDetails?: any }) {
	const dispatch = useAppDispatch();
	let { dataToEdit, handleCancelEdit, userDetails } = props;
	const isMobile = useAppSelector(getMobile);
	let { type } = useParams();
	dataToEdit = isMobile ? type : dataToEdit;

	const handleEventCancel = () => {
		if (isMobile) {
			dispatch(togglePage(`/${pagesEnum.SETTINGS}/${SettingsTabType.MyProfile}`));
		} else {
			handleCancelEdit();
		}
	};
	return (
		<Page>
			<>
				<MobileNavbar handleBack={handleEventCancel} handleCancel={handleEventCancel} />
				{(() => {
					switch (dataToEdit) {
						case FormInputsTypes.NAME:
							return (
								<EditName
									handleCancelEdit={handleEventCancel}
									dataToEdit={dataToEdit}
									userDetails={userDetails}
								/>
							);
						case FormInputsTypes.EMAIL:
							return <EditEmail handleCancelEdit={handleEventCancel} />;
						case FormInputsTypes.PHONE:
							return <EditPhone handleCancelEdit={handleEventCancel} />;
						case FormInputsTypes.LANGUAGE:
							return <EditLanguage handleCancelEdit={handleEventCancel} />;
					}
				})()}
			</>
		</Page>
	);
}
